<template>
    <div v-if="listready" class="wrapper">
        <div class="animated fadeIn">
            <b-card header="<i class='fa fa-align-justify'></i><strong> Accounts</strong>">
                <filter-form
                        :typeusers="typeusers"
                        :bedrijven="bedrijven"
                        :currentFilter="currentFilter"
                        @get-items="getItems">
                </filter-form>
                <br />
                <item-list
                        :items="items"
                        @delete-item="deleteItem">
                </item-list>
            </b-card>
        </div>

        <b-modal title="Verwijderen" size="sm" class="modal-danger" v-model="warningModal" @ok="closedialog">
            FOUT: Account werd niet verwijderd! {{errormsg}}
        </b-modal>
    </div>
</template>

<script>
    import api from '../../api/account';
    import FilterForm from './FilterForm';
    import ItemList from './List';

    export default {
        data () {
            return {
                warningModal: false,
                listready: false,
                errormsg: '',
                typeusers: [],
                bedrijven: [],
                items: [],
            };
        },
        computed: {
            currentFilter () {
                const filter = this.$store.getters.accountFilter;
                return Object.assign({}, filter);
            },
        },
        created () {
            this.getItems(true);
        },
        methods: {
            getItems (withselect) {
                this.$store.dispatch('saveAccountFilter', this.currentFilter);
                api.getListUser(withselect, this.currentFilter.typeuser, this.currentFilter.bedrijf,
                    this.currentFilter.zoekstring).then((response) => {
                    if (withselect) {
                        this.typeusers = response.data.typeusers;
                        this.typeusers.unshift({ id: 0, naam: '-- Alle --' });
                        this.bedrijven = response.data.bedrijven;
                        this.bedrijven.unshift({ id: 0, naam: '-- Alle --' });
                    }
                    this.items = response.data.items;
                    this.listready = true;
                });
            },
            deleteItem (id) {
                api.deleteUser(id).then(() => {
                    this.getItems(false);
                },
                (error) => {
                    this.errormsg = error.message;
                    this.warningModal = true;
                });
            },
            closedialog () {
                this.warningModal = false;
            },
        },
        components: {
            'filter-form': FilterForm,
            'item-list': ItemList,
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/account/Index.vue